export function storage(location) {
  const segments = location.pathname.split('/');
  if (isProjectPath(segments) && segments[4] === 'storage') {
    return true;
  } else {
    return false;
  }
}

export function projectHeader(location) {
  const segments = location.pathname.split('/');
  if (isProjectPath(segments) && segments[4] !== 'storage') {
    return true;
  } else {
    return false;
  }
}

export function notifications(location) {
  const segments = location.pathname.split('/');
  if (isProjectPath(segments) && segments[4] !== 'storage') {
    return true;
  } else {
    return false;
  }
}

export function notifications_admin(location) {
  const segments = location.pathname.split('/');
  return segments[1] == 'ui' && segments[2] === 'admin' && segments[3] === 'notifications';
}

export function qna(location) {
  const segments = location.pathname.split('/');
  if (isProjectPath(segments) && segments[4] === 'qna') {
    return true;
  } else {
    return false;
  }
}

export function reportViewer(location) {
  const segments = location.pathname.split('/');
  if (segments[1] == 'ui' && segments[2] == 'reportviewer') {
    return true;
  } else {
    return false;
  }
}

export function reporting(location) {
  const segments = location.pathname.split('/');
  if (isProjectPath(segments) && segments[4] === 'reports') {
    return true;
  } else {
    return false;
  }
}

export function teams(location) {
  const segments = location.pathname.split('/');
  if (isProjectPath(segments) && segments[4] === 'teams') {
    return true;
  } else {
    return false;
  }
}

export function dataPrivacy(location) {
  const segments = location.pathname.split('/');
  if (isProjectPath(segments) && segments[4] === 'dataprivacy') {
    return true;
  } else {
    return false;
  }
}

export function redaction(location) {
  const segments = location.pathname.split('/');
  if (segments[1] == 'ui' && segments[2] == 'redaction') {
    return true;
  } else {
    return false;
  }
}

export function eca(location) {
  const segments = location.pathname.split('/');
  if (segments[1] == 'ui' && segments[2] == 'eca') {
    return true;
  } else {
    return false;
  }
}

export function hub(location) {
  const segments = location.pathname.split('/');
  return segments[1] == 'ui' && segments[2] == 'hub';
}

export function header(location) {
  return hub(location) || eca(location);  /*TODO: || isProjectPath(location) is project header*/;
}

export function footer(location) {
  const segments = location.pathname.split('/');
  return isProjectPath(segments) && segments[4] !== 'storage';
}

function isProjectPath(segments) {
  return segments[1] === 'ui' && segments[2] === 'p' && segments[3];
}

export function auth(location) {
  const segments = location.pathname.split('/');
  if (segments[1] == 'ui' && segments[2] == 'auth') {
    return true;
  } else {
    return false;
  }
}

export function projectworkflows(location) {
  const segments = location.pathname.split('/');
  if (segments[1] == 'ui' && segments[2] == 'projectworkflows') {
    return true;
  } else {
    return false;
  }
}

export function archives(location) {
  const segments = location.pathname.split('/');
  return segments[1] == 'ui' && (segments[3] == 'archives' || segments[4] == 'archives');
}

export function projectList(location) {
  const segments = location.pathname.split('/');
  const active = segments[1].toLowerCase() === 'home' && segments[2].toLowerCase() === 'hub';
  return active;
}